module.exports = __webpack_public_path__ + "static/media/presence-icon.23e8fa17.svg";